<template>
  <div class="invoice main">
    <div v-if="t" :class="{ 'bg-pink': isFailedOrder }" :key="key">
      <div class="wrapper no-scrollbar" :key="z">
        <section class="has-text-left no-scrollbar">
          <div style="margin-bottom: 10px">
            <span
              class="tag is-pulled-right has-text-weight-semibold"
              :class="stateClass"
              style="margin-top: 4px"
              @click="print"
            >
              {{ prettyState }}
            </span>
            <h1 class="is-size-5 has-text-weight-medium" @click="z += 1">
              <span @click="preClose">
                <i class="fa fa-chevron-left" style="padding: 6px" />
                Invoice
              </span>
            </h1>
          </div>

          <p v-if="isTest" style="margin-top: -16px; padding: 4px">
            <i class="test-order" @click="showTest = false">
              This is a TEST invoice
            </i>
          </p>

          <!-- <div
            v-if="!t.is_ongoing"
            class="notification is-dark"
            style="padding: 10px"
          >
            This invoice has been paid. Thank you.
          </div> -->

          <div
            v-if="true"
            class="notification is-primary"
            style="padding: 10px"
          >
            This invoice is ready. You can pay now.
          </div>

          <div
            v-if="false"
            class="notification is-danger"
            style="padding: 10px"
          >
            This invoice is past due. Please pay it now.
          </div>

          <!-- @click="messageAgents" -->
          <div
            class="notification is-light single-line shop-name"
            style="padding: 10px"
            @click="showToDetails = !showToDetails"
          >
            <p class="is-flex">
              <span style="flex: 1"
                >To: <b>{{ t.data.business.name }}</b></span
              >
              <span style="flex-shrink: 1">
                <i v-if="showToDetails" class="fa fa-chevron-up" />
                <i v-else class="fa fa-chevron-down"
              /></span>
            </p>
            <div v-if="showToDetails">
              <p>Address</p>
              <p>Phone Number</p>
              <p>Email</p>
              <p>Tax ID</p>
            </div>
          </div>

          <div
            class="notification is-light single-line shop-name"
            style="padding: 10px"
            @click="showFromDetails = !showFromDetails"
          >
            <p class="is-flex">
              <span style="flex: 1">From: <b>TUK PTE LTD</b></span>
              <span style="flex-shrink: 1">
                <i v-if="showFromDetails" class="fa fa-chevron-up" />
                <i v-else class="fa fa-chevron-down"
              /></span>
            </p>
            <div v-if="showFromDetails">
              <p>Address</p>
              <p>Phone Number</p>
              <p>Email</p>
              <p>Tax ID</p>
            </div>
          </div>

          <!-- <div class="transaction">
            <div class="is-flex">
              <div class="ticket" @click="incrementOrderNumber">
                <p
                  class="is-size-3 has-text-weight-semibold"
                  style="line-height: 1em"
                >
                  {{ ref }}
                </p>
                <p>
                  <i class="fa is-size-4" :class="fulfilmentIcon" />
                </p>
                <p style="margin-top: -6px">{{ fulfilmentType }}</p>
              </div>
              <div style="flex: 1; padding: 8px; padding-right: 4px">
                <span
                  class="tag is-white icon is-medium has-text-success phone-btn"
                  style="margin-top: -6px"
                  @click="callPhoneNumber(t.customer.phone_number)"
                >
                  <i class="fa fa-phone" />
                </span>
                <p class="name">
                  <i class="fa fa-user fa-sm pad" />
                  <span class="link">{{ customerName }}</span>
                </p>
                <p>
                  <i class="far fa-clock fa-sm pad" />{{
                    $t("ecommerce.ordered")
                  }}
                  <span class="has-text-weight-medium">
                    {{ timeAgo(t.created_at) }}
                  </span>
                </p>
                <p>
                  <i class="fa fa-coins fa-sm pad" />
                  <span>{{ currency }}{{ orderValue }}</span>
                  <span class="has-text-link is-uppercase payment">{{
                    translatePayment(t.data.order.payment_method)
                  }}</span>
                </p>
              </div>
            </div>
          </div> -->

          <div clas="notification">
            <table class="table is-fullwidth" :key="y">
              <!-- <thead>
                <tr>
                  <th style="padding-right: 0">Invoice Summary</th>
                  <th class="right is-narrow"></th>
                </tr>
              </thead> -->
              <tbody>
                <tr>
                  <td style="padding-right: 0">
                    <span style="color: grey; font-weight: 450"
                      >Invoice Number
                    </span>
                  </td>
                  <td class="right" style="white-space: nowrap">
                    19081-898124
                  </td>
                </tr>
                <tr>
                  <td style="padding-right: 0">
                    <span style="color: grey; font-weight: 450"
                      >Invoice Date
                    </span>
                  </td>
                  <td class="right" style="white-space: nowrap">2022-02-01</td>
                </tr>
              </tbody>

              <tfoot>
                <tr class="big-table-row">
                  <th>Amount Due</th>
                  <th class="right">{{ currency }}{{ orderValue }}</th>
                </tr>
              </tfoot>
            </table>
          </div>

          <p class="has-text-grey" style="padding: 6px; font-weight: 500">
            Payment options:
          </p>
          <div class="is-flex">
            <span class="button is-link is-fullwidth" @click="payWithCard">
              <i class="fa fa-credit-card" />&nbsp;Credit Card</span
            >&nbsp;
            <span class="button is-info is-fullwidth" @click="payWithBank">
              <i class="fa fa-university" />&nbsp;Bank Transfer</span
            >
          </div>

          <hr />
          <!-- <div style="background-color: whitesmoke"> -->
          <div class="billing-summary">
            <span
              class="is-pulled-right link has-text-link"
              style="font-size: 0.8em"
              >Download CSV</span
            >
            <p class="has-text-grey" style="font-weight: 500">
              Billing Summary:
            </p>
            <p>Number of Orders: <b>112</b></p>
            <p>Order Value: <b>133,412</b></p>
          </div>

          <!-- <div v-show="orderNotes" class="order-notes">
            <i class="far fa-comment-alt has-text-grey" style="margin: 4px" />
            <i>{{ $t("ecommerce.notes") }}:</i>&nbsp;
            <span class="has-text-link has-text-weight-medium"
              >{{ orderNotes }} <i class="far fa-copy fa-sm has-text-black"
            /></span>
          </div> -->

          <div clas="notification">
            <table
              class="table is-fullwidth"
              style="background-color: whitesmoke"
            >
              <!-- <thead>
                  <tr>
                    <th style="padding-right: 0">Description</th>
                    <th class="right is-narrow">TUK Merchant Software</th>
                  </tr>
                </thead> -->
              <tbody>
                <tr>
                  <th style="padding-right: 0">Description</th>
                  <th class="right is-narrow">TUK Merchant Software</th>
                </tr>
                <tr>
                  <td style="padding-right: 0">
                    <span style="color: grey; font-weight: 450"
                      >Unit Price (Qty 1)
                    </span>
                  </td>
                  <td class="right" style="white-space: nowrap">$108</td>
                </tr>
                <tr>
                  <td style="padding-right: 0">
                    <span style="color: grey; font-weight: 450">Subtotal </span>
                  </td>
                  <td class="right" style="white-space: nowrap">$108</td>
                </tr>
              </tbody>

              <tfoot>
                <tr class="big-table-row">
                  <th>Total</th>
                  <th class="right">{{ currency }}{{ orderValue }}</th>
                </tr>
              </tfoot>
            </table>
          </div>
          <!-- </div> -->

          <div style="margin-top: 10px">
            <span class="button is-link is-outlined" @click="contactUs">
              {{ $t("contact-us") }} </span
            >&nbsp;
            <span class="button is-link is-outlined">Share Link</span>&nbsp;
            <span
              v-if="superuser"
              class="button is-dark is-outlined"
              @click="showAdvancedOptions = true"
            >
              <i class="fa fa-cog" />
            </span>

            <span class="order-id" @click="copyOrderID">
              Invoice ID<br />{{ orderID }}
            </span>
          </div>
        </section>
      </div>

      <OrderConfirmationReminderPanel
        v-if="showOrderConfirmationReminder"
        @accept="done"
        @close="closeOrderConfirmationReminder"
      />

      <CommerceAgentOrderOptionsPanel
        v-if="showAdvancedOptions"
        :t="t"
        @close="showAdvancedOptions = false"
      />
    </div>

    <div v-else class="wrapper" style="padding: 0">
      <div style="padding: 12px">
        <h1 class="is-size-5 has-text-weight-medium">
          <span @click="close">
            <i class="fa fa-chevron-left" style="padding: 6px" />
            Loading Invoice
          </span>
        </h1>
      </div>
      <div style="padding: 10px">
        <progress class="progress is-large is-white" max="1" />

        <article class="media">
          <figure class="media-left">
            <p class="image">
              <b-skeleton square width="80px" height="80px"></b-skeleton>
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <b-skeleton height="80px"></b-skeleton>
              </p>
            </div>
          </div>
        </article>

        <div style="height: 10px" />
        <b-skeleton height="40px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="30px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="200px"></b-skeleton>

        <div style="height: 20px" />
        <b-skeleton height="40px" width="200px"></b-skeleton>
      </div>
    </div>
  </div>
</template>


<script>
import OrderConfirmationReminderPanel from "@/components/OrderConfirmationReminderPanel";
import CommerceAgentOrderOptionsPanel from "@/components/CommerceAgentOrderOptionsPanel";

const shortid = require("shortid");

export default {
  name: "Invoice",
  components: {
    OrderConfirmationReminderPanel,
    CommerceAgentOrderOptionsPanel,
  },
  props: {
    id: String,
  },
  data() {
    return {
      showToDetails: false,
      showFromDetails: false,
      key: 0, // main transaction update key
      updating: false,
      t: null,
      showAdvancedOptions: false,
      showFees: false,
      orderCount: null,

      showDriverPhone: false,
      showDelivery: false,
      transaction: null,
      z: 0,
      y: 0, // for toggle item complete
      w: window.innerWidth * (2 / 3) < 500 ? window.innerWidth * (2 / 3) : 450, //window.innerWidth - 44,
      lang: this.$store.state.language,
      isPulse: true, // pulse slider until slid
      eta: 5, // default eta could be set in commerce workflow
      etas: [5, 10, 15, 20, 30, 40, 50, 60, 75, 90, 120, 180],
      retryCount: 0,
      iosTrigger: { a: false, b: false },
      showPics: false,
      showStaffNotes: false,
      showDescriptions: false,
      isSubmitted: false, // block clicks while submitting
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
      // newItemName: null,
      manualItemName: null,
      manualItemPrice: null,
      manualItemQuantity: null,
      editingOutOfStock: false,
      showTest: true, // used to hide `this is a test order`
      reminderTimeout: null,
      showOrderConfirmationReminder: false,
      confirmationReminderCount: 0,
      completedItems: {},
    };
  },
  computed: {
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    ref() {
      if (this.t.data.ref_prefix) {
        return this.t.data.ref_prefix + this.t.data.ref;
      }
      return "#" + this.t.data.ref;
    },
    isSOL() {
      if (!this.t.data.order) return false;
      return this.t.data.order.payment_method === "sol";
    },
    isPaid() {
      if (this.t.data.order.payment_method === "card") return true;
      return false;
    },
    isFailedOrder() {
      var states = ["timed_out", "cancelled_by_shop"];
      return states.includes(this.t.state);
    },
    isIOS() {
      return true;
    },
    iosClassA() {
      if (this.iosTrigger.a) return "fa fa-circle fa-2x has-text-success";
      return "far fa-circle fa-2x has-text-ccc";
    },
    iosClassB() {
      if (this.iosTrigger.b) return "fa fa-circle fa-2x has-text-success";
      return "far fa-circle fa-2x has-text-ccc";
    },
    iosA() {
      if (this.iosTrigger.a) return "color:lightgreen";
      return "color:lightgrey";
    },
    iosB() {
      if (this.iosTrigger.b) return "color:lightgreen";
      return "color:lightgrey";
    },
    state() {
      var data = this.t.data;
      // for autoconfirm it won't be confirmed if shop cancelled etc
      if (this.t.is_ongoing && data.autoconfirm && !data.event_confirmed) {
        return "initiated";
      }
      return this.t.state;
    },
    basketItems() {
      return this.t.data.order.basket.items;
    },
    languages() {
      // new way check the languages in the commerce workflow json
      if (this.workflow) return this.workflow.data.languages || ["en", "th"];
      // if (languages && languages.length) return languages; }
      // old way check languages object on first item to get languages set to true
      if (this.basketItems.length === 0) return [];
      var obj = this.basketItems[0].item.languages;
      if (!obj) return [];
      return Object.keys(obj).filter((k) => {
        return obj[k];
      });
    },
    isTest() {
      if (!this.orderNotes || !this.showTest) return false;
      return this.orderNotes.includes("TEST ORDER");
    },
    orderNotes() {
      return this.t.data.order.basket.notes;
    },
    deliveryNotes() {
      if (!this.t.data.address) return null;
      return this.t.data.address.notes;
    },
    deliverySubsidy() {
      return this.t.data.order.delivery_subsidy;
    },
    vat() {
      return this.t.data.order.vat || 0;
    },
    orderValue() {
      // add fees and discounts
      var discounts = this.t.data.order.special_discount || 0;
      var orderValue = this.t.data.order.order_value + this.vat - discounts;
      if (this.t.data.type === "delivery") {
        var deliveryFee = this.t.data.fare.price;
        if (this.lalamoveFee) orderValue += deliveryFee;
        // if (this.t.data.delivery.is_free_delivery) orderValue -= deliveryFee; // June26
        if (this.deliverySubsidy) orderValue -= this.deliverySubsidy; // was else if
      }
      return orderValue; // non delivery just return orderValue
    },
    // shows as "service fee" to shop
    deliveryFee() {
      if (this.t.data.type !== "delivery") return 0; // don't need this check now
      // if (this.t.data.delivery.is_free_delivery) return this.t.data.fare.price; // June26
      // if (this.deliverySubsidy) this.deliverySubsidy;
      return this.deliverySubsidy;
    },
    serviceFee() {
      if (this.t.data.type !== "delivery") return 0; // don't need this check now
      var fees = this.t.data.order;
      var serviceFee = fees.delivery_subsidy + fees.special_discount;
      return serviceFee;
    },
    // only used by lalamove orders for now
    netFeesAndDiscounts() {
      var fees = this.t.data.order;
      var serviceFee = fees.delivery_subsidy + fees.special_discount;
      var discounts = fees.fulfilment_discount;
      var net = -1 * (serviceFee + discounts);
      if (!this.lalamoveFee) return net;
      return net + this.lalamoveFee;
    },
    lalamoveFee() {
      if (this.t.data.type !== "delivery") return null;
      if (!this.t.data.delivery.lalamove) return null;
      return this.t.data.fare.price;
    },
    currency() {
      var country = "th"; // default country
      if (this.t.data.business) country = this.t.data.business.country;
      return this.currencySymbol(country); // should store in order
    },
    slideText() {
      return "Slide to confirm";
    },
    confirmedText() {
      return "Confirmed";
    },
    isNew() {
      return this.state === "initiated";
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    workflow() {
      return this.role.workflow; // commerce() workflow
    },
    showConfirmationReminder() {
      if (!this.workflow) return true;
      if (!this.workflow.data.agent_options) return true;
      var agentOptions = this.workflow.data.agent_options;
      return agentOptions.confirmation_popup !== "hide";
    },
    showPrepTimeSelector() {
      //   return true;
      if (!this.workflow) return null;
      // actually prep_time object should have show: t/f bool, so you can set default separately
      if (this.workflow.data.prep_time) return true; // use prep_time: {} object instead
      return this.workflow.data.prep_time_selector; // deprecate this
    },
    prepTimeDefault() {
      if (!this.workflow) return this.eta;
      if (this.workflow.data.prep_time) {
        return this.workflow.data.prep_time.default || this.eta; // new way
      }
      return this.workflow.data.prep_time_default || this.eta; // old way
    },
    isRequestingDriver() {
      if (!this.t.delivery) return false;
      var dt = this.t.delivery; // delivery transaction
      if (!dt.driver && dt.state === "initiated") return true;
      return false;
    },
    isRequestAgain() {
      if (!this.t.delivery) return false;
      var dt = this.t.delivery; // delivery transaction
      if (!dt.driver && dt.state !== "initiated") return true;
      return false;
    },
    customerName() {
      // if (this.t.customer.name === "") return this.t.customer.phone_number;
      // return this.shortenString(this.t.customer.name, 20);
      return this.t.customer.name || this.t.customer.phone_number;
    },
    driverName() {
      // if (!this.t.delivery.driver.name)
      //   return this.t.delivery.driver.phone_number;
      // return this.shortenString(this.t.delivery.driver.name, 20);
      return this.t.delivery.driver.name || this.t.delivery.driver.phone_number;
    },
    basketItemCount() {
      // if (!this.basket) return 0;
      var sum = 0;
      this.basketItems.forEach((o) => {
        sum = sum + o.quantity;
      });
      return sum;
    },
    isDelayedDelivery() {
      return this.t.data.delivery.type === "delayed";
    },
    isThirdPartyDelivery() {
      return this.t.data.delivery.type === "third-party";
    },
    prettyState() {
      if (this.state === "initiated")
        return this.$t("ecommerce.waiting-for-confirmation");
      if (this.state === "confirmed")
        return this.$t("ecommerce.being-prepared");
      if (this.state === "ready")
        return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      if (this.state === "completed") return this.$t("ecommerce.completed");
      if (this.state === "timed_out") return this.$t("ecommerce.expired");
      if (this.state === "cancelled_by_shop")
        return this.$t("ecommerce.shop-cancelled");
      return this.state;
    },
    stateClass() {
      if (this.state === "completed") return "has-text-success";
      return "has-text-dark";
    },
    isDelivery() {
      // don't show delivery stuff if order timed out or cancelled_by_shop
      if (this.isFailedOrder) return false;
      return this.t.data.type === "delivery";
    },
    deliveryState() {
      if (!this.t.delivery) return "None";
      var state = this.t.delivery.state;
      return this.translateState(state);
    },
    fulfilmentIcon() {
      var type = this.t.data.type;
      if (type === "take-away") return "fa-walking  has-text-link";
      if (type === "delivery") return "fa-shipping-fast";
      if (type === "dine-in") return "fa-users has-text-orange";
      return "fa-question has-text-danger";
    },
    fulfilmentType() {
      return this.translateFulfilmentType(this.t.data.type);
    },
    orderID() {
      var id = this.t.id;
      return id.substr(id.length - 5);
    },
    swipe() {
      var obj = null;
      if (this.state === "initiated") {
        obj = {
          text: this.$t("ecommerce.order-confirmed-?"),
          successText: this.$t("ecommerce.confirmed"),
          background: this.bulmaColor("primary"),
        };
      }
      if (this.state === "confirmed") {
        obj = {
          text: this.$t("ecommerce.ready-for-pickup-?"),
          successText: this.$t("ecommerce.ready"),
          background: this.bulmaColor("info"),
        };
      }
      if (this.state === "ready") {
        obj = {
          text: this.$t("ecommerce.order-completed-?"),
          successText: this.$t("ecommerce.completed"),
          background: this.bulmaColor("warning"),
        };
      }
      return obj;
    },
    receiptPrice() {
      if (!this.t.delivery) return null;
      return this.t.delivery.data.receipt_price;
    },
    driverProfilePic() {
      return this.t.delivery.driver.profile_pic_url || this.fallbackProfPic();
    },
  },
  mounted() {
    // FIRST check user has the necessary commerce agent role to view this order
    this.init(); // this.getCommerceAgentOrder();
  },

  methods: {
    init() {
      //   if (this.$route.name !== "commerce-agent-order") return; // try to fix bug
      var id = this.$route.params.id;
      if (id) this.getCommerceAgentOrder(id); // fix bug
    },
    print() {
      window.print();
    },
    payWithCard() {
      this.infoToast("Pay with Card");
    },
    payWithBank() {
      this.infoToast("Pay with Bank");
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast("Copied to clipboard!<br>" + txt);
    },
    closeOrderConfirmationReminder() {
      this.showOrderConfirmationReminder = false;
      this.confirmationReminderCount += 1;
    },
    infoCallCustomerDeliveryTime() {
      var msg = `If the order takes more than 45 mins<br>to prepare please call the customer<br>to arrange a convenient delivery time`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoConfirmRequestDriver() {
      var msg = `When you confirm the order we call a driver<br>They will arrive in about 20 minutes`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoDelayedRequestDriver() {
      var msg = `Request driver about 20 minutes before<br>the order is ready for pickup.`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    infoRequestingDriver() {
      var msg = `It can take 20+ minutes<br>to get a driver during peak hours`;
      this.infoToast(msg, "top", 10 * 1000);
    },
    copyDeliveryID() {
      this.$copyText(this.t.delivery.id);
      this.successToast("Copied delivery ID");
    },
    messageAgents() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.1em'><i class='fa fa-paper-plane fa-sm'></i>&nbsp;Message Commerce Agents</p>
        <p style='margin-top:10px'>Send push notification to the shop</p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: "Send Message",
        input: "textarea",
        inputValue: `TUK Invoice Ready - February 2022. Please pay the invoice soon to avoid service disruption.`,
        inputValidator: (val) => {
          if (!val || val.length < 4) return "Enter a message";
        },
      }).then((val) => {
        if (val.value) {
          var data = {
            workflow_id: this.t.workflow_id,
            message: val.value,
          };
          var loader = this.loadingDots();
          this.$store
            .dispatch("sendMessageToWorkflow", data)
            .then(() => this.successToast("Sent!"))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    getCommerceAgentOrder(id) {
      // this.t = null;
      this.updating = true;
      this.$store
        .dispatch("getCommerceOrderForAgent", id)
        .then((res) => {
          this.t = res.data; // must be a commerce order
          this.updateTimer();
          this.getCommerceOrderCount();
          this.logCommerceAgentViewedNewOrder();
          this.$nextTick(() => (this.key += 1));

          this.reminderTimeout = setTimeout(() => {
            if (this.state === "initiated" && this.showConfirmationReminder) {
              // this.remindToConfirmOrder({ val: false });
              this.showOrderConfirmationReminder = true;
            }
          }, 3000);
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updating = false));
    },
    logCommerceAgentViewedNewOrder() {
      if (this.state !== "initiated") return; // computed var that handles autoconfirm
      this.log("commerce_agent_viewed_new_order", {
        business: this.t.data.business.name,
        user: this.$store.getters.realName,
        phone: this.$store.getters.phoneNumber,
        ref: this.ref,
        transaction_id: this.t.id,
      });
    },
    updateTimer() {
      setTimeout(() => this.init(), 60 * 1000);
    },
    onVisibilityChange() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") return;
        this.init();
      });
    },
    gotoCustomerOrder() {
      this.goto("/commerce_order/" + this.t.id);
    },
    enterThirdPartyTrackingLink() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
        <i class='fa fa-link'></i>&nbsp;Input Third-Party Tracking Link</p>
        </div>`,
        input: "url",
        inputPlaceholder: "https://thaipost.com/track/abc123",
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 5) return "Enter a valid URL";
        },
      }).then((val) => {
        if (val.value) {
          //
        }
      });
    },

    toggleMenuInfo() {
      this.showPics = !this.showPics;
      this.showDescriptions = !this.showDescriptions;
      this.showStaffNotes = !this.showStaffNotes;
    },
    computeSlideWidth() {
      var w = window.innerWidth * (2 / 3); //window.innerWidth - 44; // in case window changed size
      if (w < 500) this.w = w;
      else this.w = 500;
    },
    incrementOrderNumber() {
      if (!this.superuser) return;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-ticket-alt'></i>&nbsp;
          Order ${this.ref}
        </p>
        <p>Click <strong>Increment</strong> to change the order number.</p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: "Increment",
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots();
          this.$store
            .dispatch("incrementCommerceOrder", this.t.id)
            .then(() => {
              this.successToast("Increment success!");
              this.updateOrdersCommerceAgent(true);
              setTimeout(() => this.close(), 800);
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    orderCountInfo() {
      var msg = `This customer is ordering<br>from you for the first time!`;
      if (this.orderCount) {
        msg = `This customer has ordered<br>from you ${this.orderCount} times!`;
      }
      this.successToast(msg, "top");
    },
    getCommerceOrderCount() {
      var payload = {
        workflowID: this.t.workflow_id,
        userID: this.t.created_by,
      };
      this.$store
        .dispatch("getCommerceOrderCount", payload)
        .then((res) => {
          console.log("getCommerceOrderCount", res.data);
          this.orderCount = res.data;
        })
        .catch((err) => this.apiError(err));
    },

    shareToCustomer() {
      var path = "/commerce_order/" + this.t.id;
      if (this.t.data.short_id) path = "/o/" + this.t.data.short_id;
      var url = window.location.origin + path;
      this.$copyText(url);
      if (!navigator.share) {
        var msg = `Order share link copied to clipboard<br>${url}`;
        this.infoToast(msg, "top");
        return;
      }
      var shareMsg = `🛺 Here's your TUK App order for ${this.role.business.name}
👉🏼 ${url}`;
      navigator
        .share({ text: shareMsg })
        .catch((err) => this.console("Error sharing", err));
    },
    copyOrderID() {
      this.$copyText(this.t.id);
      this.infoToast(`Copied Order ID<br>${this.t.id}`);
    },
    preClose() {
      // if (this.state === "initiated") this.remindToConfirmOrder({ val: true });
      if (this.state === "initiated") {
        if (this.confirmationReminderCount < 2) {
          this.showOrderConfirmationReminder = true;
        } else {
          var line1 = this.$t("commerce.please-confirm-order-asap");
          var line2 = this.$t("commerce.it-will-expire");
          var msg = `${line1}<br>${line2}`;
          setTimeout(() => this.errorToast(msg, "top", 1000 * 10), 1000);
          this.close();
        }
      } else this.close();
    },
    close() {
      if (this.superuser) {
        if (window.history.length <= 2) return this.goto("ecommerce");
        this.$router.go(-1);
      } else {
        this.goto("ecommerce");
      }
    },
    remindToConfirmOrder(close) {
      if (this.state !== "initiated") return;
      console.log("remindToConfirmOrder", this.state, this.t);
      var title = this.$t("commerce.accept-order");
      var text1 = this.$t("commerce.is-your-shop-open-now");
      var text2 = this.$t("commerce.if-not-cancel-order");
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-exclamation'></i>&nbsp;${title} ???
        </p>
        <p style='margin-bottom:10px'>${text1}</p>
        <p><i>${text2}</i></p>
        </div>`,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("success"),
        confirmButtonText: this.$t("accept"),
        cancelButtonText: this.$t("i-dont-know"),
      }).then((val) => {
        if (val.value) this.done();
        else {
          if (close.val) {
            var line1 = this.$t("commerce.please-confirm-order-asap");
            var line2 = this.$t("commerce.it-will-expire");
            var msg = `${line1}<br>${line2}`;
            setTimeout(() => this.errorToast(msg, "top", 1000 * 10), 1000);
            this.close();
          }
        }
      });
    },
    addManualItem() {
      if (!this.manualItemName || !this.manualItemPrice) {
        this.infoToast("Enter item name and price", "top");
        return;
      }
      if (!this.manualItemQuantity) this.manualItemQuantity = 1;
      var manualItem = {
        id: "~" + shortid.generate(), // needs a random ID, stat with ~
        name: this.manualItemName,
        price: parseInt(this.manualItemPrice),
        description: "Added by shop",
      };
      this.basketItems.push({
        item: manualItem,
        quantity: parseInt(this.manualItemQuantity),
      }); // this.addToBasket(manualItem);
      this.t.data.order.order_value = this.basketValue(); // update the order value
      this.submitOrderEdit();
    },
    basketValue() {
      var basket = this.t.data.order.basket;
      var value = 0;
      basket.items.forEach((o) => {
        value = value + this.discountedTotalPrice(o.item) * o.quantity;
      });
      return value;
    },
    resetOrderEdit() {
      this.manualItemName = null;
      this.manualItemPrice = null;
      this.manualItemQuantity = null;
      this.showEditOrder = false;
    },
    submitOrderEdit() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id, //data.order.basket.items;
          data: {
            data: { order: this.t.data.order, edited: true }, //event_edited: true },
          },
        })
        .then(() => {
          this.resetOrderEdit();
          this.successToast("Edited order 👍🏼");
          this.updateOrdersCommerceAgent(true);
          setTimeout(() => this.close(), 800);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleItemComplete(item) {
      var itemID = item.id2 || item.id;
      this.completedItems[itemID] = !this.completedItems[itemID];
      this.y += 1;
      console.log("completed", this.completedItems);
    },
    itemComplete(item) {
      return this.completedItems[item.id2 || item.id];
    },
    optionMenuName(o) {
      var menu = o.menu.name;
      if (o.menu[this.lang]) menu = o.menu[this.lang];
      return menu;
    },
    optionItemName(o) {
      var option = o.option.name;
      if (o.option[this.lang]) option = o.option[this.lang].name;
      return option;
    },
    isSpecialItem(o) {
      if (o.item.id && o.item.id.startsWith("~")) return true;
      return false;
    },
    // init(t) {
    //   this.transaction = t;
    //   this.eta = this.prepTimeDefault; // 5 minutes or whatever is set in workflow json
    //   this.isPulse = true;
    //   this.iosTrigger = { a: false, b: false };
    //   this.computeSlideWidth();
    //   this.z += 1;
    // },
    iosSlide(x) {
      this.iosTrigger[x] = true;
      if (this.iosTrigger.a && this.iosTrigger.b) this.done();
    },
    itemName(o) {
      if (o[this.lang]) {
        return o[this.lang].name;
      }
      return o.name;
    },
    itemDescription(o) {
      if (o[this.lang]) {
        return o[this.lang].description; // || "~";
      }
      return o.description; // || "~";
    },
    openNotesReminder() {
      if (!this.orderNotes) return;
      this.$swal({
        html: `<div style='text-align:left'>
            <p style='font-size:1.2em; margin-bottom:10px'>
              <i class="far fa-bell" style='color:red'></i>&nbsp;Note From Customer:
            </p>
            <p><i>${this.orderNotes}</i></p>
            </div>`,
        confirmButtonText: this.$t("i-acknowledge"),
      });
    },
    done() {
      if (this.reminderTimeout) clearTimeout(this.reminderTimeout);
      this.log("commerce_agent_swiped", this.t);
      this.isSubmitted = true; // hides buttons/slider while submitting to disallow multiple submits
      setTimeout(() => (this.isSubmitted = false), 8 * 1000); // reset buttons after 8 seconds
      if (this.state === "initiated") this.openNotesReminder();
      if (this.isDelivery && !this.t.delivery) {
        if (this.state === "initiated" && !this.isDelayedDelivery) {
          return this.createDeliveryTransaction(); // create delivery first
        } else if (this.state === "confirmed" && this.isDelayedDelivery) {
          return this.createDeliveryTransaction(); // create delivery first
        }
      }
      this.isPulse = false;
      // increment order state: initiated -> confirmed, confirmed -> ready
      var state = "confirmed";

      if (this.state === "confirmed") {
        state = "ready";
      }
      if (this.state === "ready") {
        state = "completed";
      }
      var data = null;
      if (this.isNew) data = { prep_time: this.eta };

      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            state: state,
            handled_by: this.userID(), // should log all state changes in DB by who did it
            data: data,
          },
        })
        .then(() => {
          this.updateOrdersCommerceAgent(true);
          setTimeout(() => this.close(), 800);
        })
        .catch((err) => {
          this.apiError(err);
          this.close();
          this.errorToast("Please try again 🤕");
          this.updateOrdersCommerceAgent();
        })
        .finally(() => {
          loader.hide();
          setTimeout(() => (this.isSubmitted = false), 1500); // reset this to allow submit again
        });
    },
    contactUs() {
      var title = "Need help?";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
        <i class="fa fa-headset"></i>
        &nbsp;${title}
        </p>
        <p style='margin-top:12px'>
        Contact us anytime you need help with your invoice.
        </p>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "Live Chat",
        cancelButtonColor: this.bulmaColor("info"),
        confirmButtonText: "Email Support",
        confirmButtonColor: this.bulmaColor("link"),
      }).then((result) => {
        this.console("reject result", result);
        if (result.dismiss === "cancel") {
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.t.id,
              data: { state: "cancelled_by_shop" },
            })
            .then(() => {
              this.updateOrdersCommerceAgent(true);
              setTimeout(() => this.close(), 1000);
              this.log("order_cancelled_by_shop");
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    restartOrder() {
      this.warningToast("Restart this order - coming soon!");
    },
    createDeliveryTransaction() {
      this.infoToast("👍🏼<i class='fa fa-spinner fa-spin' />", "top");
      var t = this.t;
      var pickup = {
        id: "business_address",
        name: t.data.business.name,
        lat: t.data.business.lat,
        lon: t.data.business.lon,
      };
      var dropoff = {
        id: "delivery_address",
        name: t.data.address.name,
        lat: t.data.address.lat,
        lon: t.data.address.lon,
        notes: this.deliveryNotes,
      };
      var delivery = {
        type: t.data.business.type,
        business_name: t.data.business.name,
        workflow_id: t.workflow_id,
        agent_id: this.userID(), // so you can get notified of delivery events
        order_value: this.orderValue,
        payment_method: t.data.order.payment_method, //"cash",
        is_free_delivery: t.data.delivery.is_free_delivery, // 22 Aug 2020
        promo_code: t.data.delivery.promo_code, // @0909588716
        contactless_note: t.data.delivery.contactless_note,
        business_note: t.data.delivery.business_note, // shop note?
        delivery_subsidy: t.data.order.delivery_subsidy,
        require_receipt: t.data.delivery.require_receipt,
      };
      if (t.data.assign_driver) {
        delivery.assign_driver = t.data.assign_driver;
      }
      if (t.data.order.cashback) {
        delivery.cashback = t.data.order.cashback;
      }
      delivery.express_fleet = t.data.delivery.express_fleet;
      if (t.data.delivery.fallback_fleet) {
        delivery.fallback_fleet = t.data.delivery.fallback_fleet;
      }
      if (t.data.delivery.lalamove) {
        delivery.lalamove = t.data.delivery.lalamove;
        delivery.lalamove.tuk_order_ref = t.data.ref; // change to computed ref?
      }
      var obj = {
        type: "delivery",
        pickup_stop: pickup,
        dropoff_stop: dropoff,
        fare: t.data.fare,
        ref: t.data.ref, // reference number
        ref_prefix: t.data.ref_prefix, // optional
        delivery: delivery,
        commerce_transaction_id: this.t.id, // so we can link back to original commerce txn
        commerce_created_at: this.t.created_at,
      };
      if (t.data.delivery.reversed) {
        obj.pickup_stop = dropoff;
        obj.dropoff_stop = pickup;
      }
      if (t.data.delivery.predicted_route) {
        obj.predicted_route = t.data.delivery.predicted_route;
      }
      if (this.eta > 15) {
        var now = new Date();
        var scheduledTime = new Date(now.getTime() + 60000 * this.eta);
        obj.scheduled_time = scheduledTime.toISOString();
      }
      if (this.workflow.data.driver_blacklist) {
        obj.driver_blacklist = this.workflow.data.driver_blacklist;
      }
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Delivery",
          workflow_id: t.data.delivery.workflow_id,
          business_id: t.data.business.id, // restaurant business ID
          created_by: t.created_by,
          data: obj,
        })
        .then((res) => {
          this.log("ecommerce_create_delivery", this.retryCount);
          this.successToast(this.$t("delivery.requesting-delivery-driver"));
          this.t.delivery = res.data;
          this.done(); // goes back to update commerce dispatch state
        })
        .catch((err) => {
          this.$store.dispatch("logError", {
            type: "ecommerce_create_delivery",
            error: err.toString(),
            retry_count: this.retryCount,
          });
          console.error("createDeliveryTransaction", err);
          if (err.message === "Network Error" && this.retryCount < 3) {
            setTimeout(() => this.createDeliveryTransaction(), 1500);
            this.retryCount += 1;
            this.warningToast("Retrying 🤞🏽");
          } else {
            this.apiError(err);
            this.isSubmitted = false; // in case of error without retry
            this.close();
            this.errorToast("Please try again 🤕");
            this.updateOrdersCommerceAgent();
          }
        });
    },
    // probably deprecate this because I automatically retry from server till infinite...
    retryDelivery() {
      var t = this.t.delivery;
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } },
        })
        .then(() => {
          this.thankYou("We are retrying the delivery request 🤞🏽");
          this.updateOrdersCommerceAgent(true);
          setTimeout(() => this.close(), 1000);
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* max-width: 600px; */
  /* margin: auto; */
  background-color: rgb(255, 255, 255);
  z-index: 21;
  backdrop-filter: blur(3px);
  overflow: hidden;
  text-align: left;
}
.total-sol {
  /* margin-left: 6px; */
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  font-weight: 500;
  color: black;
}
.bg-pink {
  background-color: lavenderblush;
}
.wrapper {
  padding: 12px;
  padding-bottom: 24px;
  text-align: left;
  height: 100vh;
  overflow: auto;
  max-width: 600px;
  margin: 0 auto;
  outline: 1px solid #ccc;
}
.transaction {
  position: relative;
  /* width: 100%; */
  border-radius: 3px;
  border: 1px solid lightgrey;
  /* box-shadow: 0px 1px 1px lightgrey; */
}
.driver {
  margin-top: 8px;
}
.columns {
  margin: 0 0;
  padding: 4px 8px;
  /* width: 100%; */
}
.column.is-1 {
  padding: 0 0;
}
.ios-btn {
  padding: 0;
  font-size: 1.2em;
  height: 38px;
}
.ticket {
  background-color: azure;
  border: 2px dotted grey;
  border-radius: 3px;
  padding: 4px;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  flex-shrink: 1;
  text-align: center;
}
.tags {
  margin-bottom: 0;
}
.tags .tag {
  margin-bottom: 0;
}
.pad {
  margin-right: 8px;
  opacity: 0.7;
}
p {
  margin-bottom: 0px !important;
}
.pulse {
  animation: glow 0.8s infinite alternate;
}
@keyframes glow {
  to {
    text-shadow: 0 0 5px yellow, 0 0 10px yellow, 0 0 15px yellow,
      0 0 25px yellow;
  }
}
.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.is-orange {
  background-color: orange;
}
.table {
  /* background-color: rgb(245, 245, 245); */
  /* border-radius: 2px; */
  margin-top: 10px;
  margin-bottom: 2px;
  /* border: 1px solid grey; */
  box-shadow: 0px 0px 1px grey;
}
.table .right {
  text-align: right;
}
.prep-time-selector {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 3px;
  /* background-color: yellow; */
  /* background-color: #ffdd57; */
  border: 1px solid orange;
}
.eta-btns {
  width: calc(((100vw - 24px) / 4) - 14px);
  max-width: calc(((600px - 24px) / 4) - 14px);
}
/* /////////////////////////// */
img {
  border-radius: 3px;
}
.driver-img {
  /* border: 1px solid black; */
  object-fit: cover;
  height: 70px;
  width: 70px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}
.item-img {
  /* height: 140px !important;
  width: auto; */
  object-fit: cover;
  height: 140px;
  width: 140px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  margin-right: 4px;
}
.tag {
  padding: 0 6px;
}
.staff-notes {
  background-color: #fed8b1;
  padding: 0 2px;
  border-radius: 2px;
  box-shadow: 0 0 1px grey;
}
.description {
  background-color: lightyellow;
  padding: 0 2px;
  border-radius: 2px;
  box-shadow: 0 0 1px grey;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.payment {
  background-color: snow;
  padding: 0 4px;
  border-radius: 4px;
  margin-left: 4px;
  font-weight: 500;
}
.more-info {
  /* background-color: rgba(255, 255, 0, 0.6); */
  padding: 2px;
  border-radius: 3px;
  margin-left: -6px;
  width: calc(100% + 12px);
  /* border: 1px solid #ddd; */
}
.options {
  background-color: rgba(255, 255, 0, 0.6);
  padding: 2px;
  border-radius: 3px;
  margin-left: -6px;
  width: calc(100% + 12px);
  border: 1px solid #ddd;
}
.td-options {
  padding-top: 0;
}
.options td {
  border-bottom: 1pt solid black;
  padding: 2px 6px;
}
.option-menu {
  font-weight: 500;
  opacity: 0.5;
  font-size: 0.9em;
}
.no-bottom-border td {
  border-bottom: none;
  /* padding-bottom: 0; */
}
tbody.items {
  width: 100%;
  border-bottom: 1px solid rgb(215, 215, 215);
  background-color: rgb(245, 245, 245);
}
.item-complete {
  background-color: rgb(205, 255, 204) !important;
}
.edit-order-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  /* background-color: #9ff8ead8; */
  /* background-color: rgba(221, 221, 221, 0.9); */
  background-color: rgba(238, 238, 238, 0.95);
  backdrop-filter: blur(4px);
  border-radius: 4px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
}
.test-order {
  font-size: 0.7em;
  font-weight: 550;
  opacity: 0.7;
  color: red;
}
.order-notes {
  margin: -1px;
  /* margin-top: 4px; */
  margin-top: 6px;
  margin-bottom: -4px;
  background-color: rgba(255, 255, 0, 0.6);
  padding: 3px;
  border-radius: 3px;
  box-shadow: 0px 0px 1px grey;
}
.billing-summary {
  margin-top: 6px;
  padding: 6px;
  /* padding-bottom: 0; */
  background-color: whitesmoke;
  border-radius: 2px;
}
.cancel-edit {
  float: left;
  color: #555;
}
.plate-number {
  position: sticky;
  margin-top: -6px;
  width: 70px;
  border: 1px dotted black;
  background-color: rgba(221, 221, 221, 0.7);
  border-radius: 3px;
  line-height: 1.2em;
  font-size: 0.8em;
  font-weight: 500;
  text-overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
}
.name {
  width: calc(100vw - 170px);
  max-width: calc(600px - 170px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.has-text-ccc {
  color: #ccc;
}
.map-btn {
  width: 100%;
  font-weight: 550;
  text-shadow: 0 0 3px white, 0 0 1px white, 0 0 4px white;
  /* margin-bottom: 20px; */
  background-image: url("~@/assets/map_button_background.png");
  background-size: cover;
  background-position: top;
  margin-top: 5px;
}
.map-btn:hover {
  color: blue !important;
}
.order-cnt {
  float: right;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.5;
  height: 0;
  margin-top: -10px;
  line-height: 1em;
}
.big-table-row {
  font-size: 1.3em;
  line-height: 1em;
  /* vertical-align: bottom; */
}
.phone-btn {
  float: right;
}
thead th {
  background-color: white;
  border-bottom: 1px solid #ddd;
}
.tuk-express {
  font-size: 12pt;
  font-weight: 550;
  color: #fac002;
  position: absolute;
  margin-top: 2px;
  margin-left: 2px;
  text-shadow: 0 0 1px white;
}
.driver-wrapper {
  border: 1px solid #ddd;
  border-radius: 4px;
}
.category-name {
  font-weight: 500;
  color: #999;
  display: block;
}
.notification {
  margin-bottom: 10px;
}
.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: inline-block; */
  max-width: 100%;
}
.shop-name {
  font-weight: 500;
  color: grey;
}
.info {
  padding: 3px 0;
  color: black;
  float: right;
}
.order-id {
  float: right;
  background-color: #eee;
  border: 1px solid #ddd;
  font-size: 0.7em;
  text-align: center;
  border-radius: 4px;
  padding: 0 3px;
  font-family: monaco;
}
</style>

<style>
.dv_handler {
  margin-top: 1px;
  margin-left: 1px;
}
</style>